<template>
    <v-layout :id="info.notification_id"
              wrap
              justify-space-around
              align-start
              class="notifications_block"
              @click="click_notifications(info)"
    >
        <v-flex row class="notifications__img-block"
                xs3 ld2 md2
        >
            <div class="norifications_img" :style="{backgroundImage: `url(${url + info.avatar})`}">
                <div class="norifications_img" :style="{backgroundImage: `url(${url + info.avatar})`}"></div>
            </div>
        </v-flex>
        <v-flex column class="notifications_body"
                ld10
                md10 xs9
        >
            <v-layout row class="notifications__title-row" wrap
                      justify-space-between
            >
                <v-flex row class="notifications__title"
                        xs12 ld6 md6
                >
                    {{ info.title }}

                    <span class="notifications_time">
                        {{ info.date | day }}
                        {{ info.date | time }}
                    </span>
                </v-flex>
                <v-flex class="custom__btn" ld6 md6
                        xs12
                >
                    <v-layout justify-start>
                        <v-flex row class="notifications__date" justify-end
                                xs4 ld6 md4
                        />
                        <v-flex xs4 md4>
                            <a @click="open_item(info.notification_id)">
                                <roundButton :icon_name="$store.state.id === info.notification_id ? 'minus' : 'plus'" :class="{'btn--icon-white': $store.state.id === info.notification_id, 'ml-3': $vuetify.breakpoint.smAndDown, 'ml-4': $vuetify.breakpoint.mdAndUp}" />
                            </a>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
            <v-flex row xs12 md12
                    class="notifications__descr"
                    @click.stop="click_notifications(info, true)"
            >
                <Transition name="bounce">
                    <span
                        v-if="info.notification_id === $store.state.id" v-html="info.description"
                    >
                    </span>
                </Transition>
            </v-flex>
        </v-flex>
        <v-flex row class="notifications__descr descr-mobile" xs12
                @click.stop="click_notifications(info, true)"
        >
            <Transition name="bounce">
                <span v-if="info.notification_id === $store.state.id" v-html="info.description"></span>
            </Transition>
        </v-flex>
    </v-layout>
</template>

<script>
import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
import orderby from 'lodash.orderby';
import roundButton   from '@/components/ui/buttons/buttons_icon/round_button';

export default {
  name      : 'NotificationRecord',
  components: {
    roundButton,
  },
  props: {
    'info': Object,
  },
  computed: {
    ...mapState('common', [
      'url',
    ]),
  },
  destroyed() {
    this.set_read_note(this.$store.state.id);
    this.get_notifications();
  },
  methods: {
    ...mapMutations('news_main', [
      'SET_CURRENT_ID',
    ]),
    ...mapMutations('notifications/Notifications_items', [
      'SET_READ_MESSAGE',
    ]),
    ...mapActions('notifications/Notifications_items', ['get_notifications']),
    ...mapActions('notifications/Notifications_items', [
      'set_read_note',
    ]),
    go_to(item) {
      this.$emit('emit_go_to', item);
    },
    open_item(id) {
      if (this.$store.state.id !== id) {
        this.$store.state.id = id;
      } else {
        this.$store.state.id = null;
      }
    },
    async click_notifications(item, open) {
      const {id, notification_id} = item;

      this.SET_CURRENT_ID(id);/*
      this.SET_READ_MESSAGE(item);*/

      await this.set_read_note(notification_id);
    },
  },
};
</script>

<style scoped>
.btn--icon-rounded:hover {
  -webkit-box-shadow: 0 5px 20px 0 rgb(0 0 0 / 10%);
  box-shadow: 0 5px 20px 0 rgb(0 0 0 / 10%);
  background-color: #ffffff;
}
.btn--icon-rounded:hover .btn--icon .icon {
  color: red!important;
}
@media (min-width: 0) {
  .flex.notifications__title.row.xs12.ld6.md6 {
    max-width: 80%;
  }
  .flex.notifications__img-block.row.xs3.ld2.md2 {
    display: none;
  }
  .flex.custom__btn.ld6.md6.xs12 {
    max-width: 20%;
  }
  .notifications_time {
    margin-left: 0px;
  }
}
</style>
